import { PaymentCurrencyUnitType } from "@/src/store/apis/subscription/interface";

/**
 * 세법상 부가세 계산 방식으로 공급가 계산
 * - KRW: 소수점 첫째 자리 반올림(정수)
 * - USD: 소수점 둘째 자리 반올림
 */
export const calculateUnitPrice = (
  displayPrice: number,
  currencyUnit: PaymentCurrencyUnitType
): number => {
  const raw = displayPrice / 1.1;
  
  // 원화는 소수점 첫째 자리에서 반올림(정수), 달러는 소수점 둘째 자리에서 반올림
  if (currencyUnit === "KRW") {
    return Math.round(raw);
  } else {
    return Math.round(raw * 100) / 100;
  }
};

/**
 * 부가세 계산 (총액 - 공급가)
 */
export const calculateTax = (
  displayPrice: number,
  unitPrice: number
): number => {
  return displayPrice - unitPrice;
};

/**
 * 표시금액 계산
 * - KRW: 서버에서 받은 price 그대로
 * - USD: price / exchangeRate
 */
export const calculateDisplayPrice = (
  price: number,
  currencyUnit: PaymentCurrencyUnitType,
  exchangeRate: number
): number => {
  return currencyUnit === "USD" ? price / exchangeRate : price;
};
